var option_webview_default = {
  "option": "vvmKz",
  "user_choice": "czVJU",
  "check": "L2a9P",
  "image": "dfB3g",
  "input": "oSSEe",
  "title": "m7MiD",
  "centered": "OrRPs",
  "with_result": "dbj7v",
  "list": "_1TYDc",
  "with_image": "yHpXT",
  "progress": "iZq2h",
  "progress_value": "Ns-Rz",
  "label": "ZyhCB",
  "cta": "_66whv",
  "adornment_icon": "Nd1Q2",
  "remove": "vPypY",
  "removeButton": "-fbQW",
  "removeButtonIcon": "PJaBA",
  "overlay": "gfC0h",
  "shown": "jkCzs",
  "dark": "FWu76",
  "spinner": "i3bVK",
  "spin": "FNR-X",
  "grid": "_2Dt0b"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
